import { useEffect, useState } from 'react';
import { BlockStack, Button, Modal, Text } from '@shopify/polaris';
import { withRouter } from 'react-router';
import { reqGetNewUserPricingPlanList, reqGetSubscription } from "../../api";
import Language from "../../i18n/Language";
import "./index.scss";
import { store } from '../../redux/store';
import { computeBestDiscount } from '../../utils/planRateCalc';

const t = Language;

const NewDiscountUpgradeModal = (props) => {

    const {
        trial_days,
        openState,
        upgradeModalType,
        isComboUser,

        cioPlanDataSet,
        handleOpenCwComboModal,
        changeUpgradeState,
        getPageDataRedux,
        toggleToast,
        sendDataToMain,
    } = props;

    const [paidLoading, setPaidLoading] = useState(false);  // 支付加载状态
    const [open, setOpen] = useState(false);  // 弹窗是否打开
    const [userlevel, setUserlevel] = useState(1);  // 用户等级
    const [trialDays, setTrialDays] = useState(0);  // 试用天数
    const [planLoading, setPlanLoading] = useState(true);  // 价格方案加载状态
    const [imgUrl, setImgUrl] = useState(""); // 图片地址
    const [planInfoData, setPlanInfoData] = useState({
        pro: {},
        pre: {},
    });  // 预选方案
    const [planResData, setPlanResData] = useState({});  // 价格方案数据
    const [planType, setPlanType] = useState('pro'); // pro ||  pre
    const preList = [
        t("Audit unlimited pages to fix SEO issues"),
        t("Boost site speed with Turbo Optimization"),
        t("Analyze competitor keywords to stay ahead"),
        t("Monitor all backlinks to protect your rankings")
    ]
    const proList = [
        t("Generate AI-powered content plans for traffic"),
        t("Boost site speed with Rocket Optimization"),
        t("Auto-add meta tags & structured data"),
        t("Auto-redirect broken links to keep SEO health")
    ]

    // 检查图标
    const checkIcon = <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.5 9L7.5 12L13.5 6" stroke="var(--color-primary)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

    // 设置弹窗样式
    const changePopoverCss = (isSet = true) => {
        const STYLE_ID = 'upgrade-modal-size-style';
        let styleEl = document.getElementById(STYLE_ID); // 识别唯一id
        if (isSet) {
            if (!styleEl) {
                styleEl = document.createElement('style');
                styleEl.id = STYLE_ID;
                styleEl.textContent = `
                    .Polaris-Modal-Dialog__Modal.Polaris-Modal-Dialog--sizeLarge {
                        max-width: 700px;
                    }
                `;
                document.head.appendChild(styleEl);
            }
        } else {
            setTimeout(() => {
                if (styleEl) {
                    styleEl.remove();
                }
            }, 500)
        }
    }

    // 跳转价格页（有 save bar 时需 leaveConfirmation，不可直接 hide + push，否则会打断后续路由刷新）
    const jumpPricing = async () => {
        const isShopify = window.shopify;
        if (isShopify && window.opener) {
            sendDataToMain({ url: "/plan", _state: null, _query: null }, 'url');
            return;
        }

        const navigateToPlan = () => {
            handleCloseModal();
            props.history.push({
                pathname: "/plan",
                query: null,
            });
        };

        if (isShopify && window.savebarState) {
            isShopify.saveBar.leaveConfirmation();
            return;
        }

        navigateToPlan();
    }

    // 获取价格方案
    const getPricingPlan = async (type = '') => {
        let _actData = store.getState().public.ActMealData;
        let _page = store.getState().page;
        let cache = _page.pageInit?.pricingPlan;
        if (Object.keys(_actData).length > 0) {
            let params = {
                activity_id: _actData.activity_id,
            };
            let res = cache || await reqGetNewUserPricingPlanList(params);
            if (res.ack === 1) {
                getPageDataRedux(res, 'pricingPlan'); // 设置价格缓存数据
                setPlanLoading(false);
                let planInfo = {
                    pro: computeBestDiscount(res.data, res.data.meal_list.month[0]),
                    pre: computeBestDiscount(res.data, res.data.meal_list.month[1]),
                }
                setPlanInfoData(planInfo);
                setPlanResData(res.data);
                setUserlevel(res.data.level);

                // posthog 弹窗埋点
                props.cwreportCustomBehavior('guide_entry_exposure', {
                    source_type: "feature_limit",
                    planRes: res.data,
                    planInfo,
                    selData: (type || planType) === 'pro' ? planInfo.pro : planInfo.pre,
                });
            } else {
                toggleToast(res.msg, true);
            }

            setPlanLoading(false);
        } else {
            setTimeout(() => {
                getPricingPlan(type);
            }, 500)
        }
    }

    // 关闭弹窗
    const handleCloseModal = () => {
        setOpen(false);
        changeUpgradeState();
    }

    // 升级方案
    const handleUpgradePlan = async () => {
        setPaidLoading(true);
        let selData = planType === 'pro' ? planInfoData.pro : planInfoData.pre;
        // 判断是否组合付费用户 
        if (isComboUser) {
            setPaidLoading(false);
            handleOpenCwComboModal('upgradeModalShow');  // 打开提示弹窗
        } else {
            // 获取套餐来源
            const _params = {
                source_type: "feature_limit",
                planRes: planResData,
                planInfo: planInfoData,
                selData,
            }
            let _t = props.handleGetPlanSource('enter_checkout', _params);

            let params = {
                ppid: selData.id,
                price: Number(selData.price),
                is_verify: 0,

                source_type: _t.source_type,
                source_position: _t.source_position,
                plan_type: _t.plan_type,
                plan_version: _t.plan_version,
                discount: _t.discount,
                paid_type: _t.paid_type,
            }
            // 活动折扣
            if (selData.rate) {
                params.activity_id = selData.activity_id;
            }
            // 优惠券折扣
            if (selData.code) {
                params.coupon_code = selData.code;
            }
            // cio埋点
            let yPrice = (selData.price / 12).toFixed(2);
            cioPlanDataSet(([2, 4].includes(selData.id) ? 'monthly' : [8, 9].includes(selData.id) ? 'annually' : ''), ([2, 8].includes(selData.id) ? 'Pro Plan' : [4, 9].includes(selData.id) ? 'Pre Plan' : ''), 0, ([8, 9].includes(selData.id) ? yPrice : selData.price));
            // posthog 支付埋点
            props.cwreportCustomBehavior('enter_checkout', _params);
            // 请求
            const res = await reqGetSubscription(params);
            if (res.ack === 1) {
                //跳转支付页面
                let j_url = res.data.jump_url;
                if (j_url) {
                    if (window.top) {
                        window.top.location.href = j_url;
                    } else {
                        handleJumpSubUrl(j_url);
                    }
                }
            } else {
                toggleToast(res.msg, true);
                setPaidLoading(false);
            }
        }
    }

    // 监听支付跳转
    const handleJumpSubUrl = (j_url) => {
        if (window.top) {
            window.top.location.href = j_url;
        } else {
            setTimeout(() => {
                handleJumpSubUrl(j_url);
            }, 5000)
        }
    }

    // 监听弹窗打开更改宽度
    useEffect(() => {
        setPlanType(openState); // 设置方案类型
        let _state = Boolean(openState);
        setOpen(_state);
        changePopoverCss(_state);
        if (_state) {
            getPricingPlan(openState);
        }
    }, [openState]);

    // 路由监听
    useEffect(() => {
        const imgList = {
            "Backlink": "/imgs/upgrade/Backlink.png",
            "Competitor": "/imgs/upgrade/Competitor.png",
            "MyKeywords": "/imgs/upgrade/MyKeywords.png",
            "GoogleConsole": "/imgs/upgrade/GoogleConsole.png",
            "InstantIndex": "/imgs/upgrade/InstantIndex.png",
            "JSONLD": "/imgs/upgrade/JSONLD.png",
            "StructuredData": "/imgs/upgrade/StructuredData.png",
            "KeywordPlanner": "/imgs/upgrade/KeywordPlanner.png",
            "Localbusiness": "/imgs/upgrade/Localbusiness.png",
            "MetaTag": "/imgs/upgrade/MetaTag.png",
            "SpeedUpPro": "/imgs/upgrade/SpeedUp-pro.png",
            "SpeedUpPre": "/imgs/upgrade/SpeedUp-pre.png",
            "404": "/imgs/upgrade/404.png",
            "AMP": "/imgs/upgrade/AMP.png",
            "OnpageSEO": "/imgs/upgrade/OnpageSEO.png",
            "AIInternalLinking": "/imgs/upgrade/AIInternalLinking.png",
            "LLmsTxt": "/imgs/upgrade/LLmsTxt.png"
        }
        const urlCompareUrl = upgradeModalType ? (imgList[upgradeModalType] || imgList["Backlink"]) : imgList["Backlink"];
        setImgUrl(urlCompareUrl);
    }, [openState, upgradeModalType])

    // 监听试用天数
    useEffect(() => {
        setTrialDays(trial_days);
    }, [trial_days]);

    useEffect(() => {
        return () => {
            changePopoverCss(false);
        }
    }, []);

    // 弹窗内容
    const modalContent = (
        <Modal
            open={open}
            onClose={handleCloseModal}
            size="large"
        >
            <div className='new_discount_upgrade_modal_content'>
                <div className="modal-container">
                    {/* Left Section */}
                    <div className="left-section">
                        {/* Upgrade banner */}
                        <div className="upgrade-banner">
                            <span className="rocket-icon">
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.64628 8.48424C4.42095 9.27157 4.51062 10.1179 3.65195 10.9906C3.11995 11.5309 2.25862 11.8556 1.07328 11.9946C1.01195 12.0019 0.949949 12.0016 0.888283 11.9942C0.471616 11.9436 0.167283 11.5732 0.187283 11.1502L0.191616 11.0949L0.208616 10.9549C0.353949 9.82491 0.668616 8.99757 1.17962 8.47824C2.03828 7.60591 2.87128 7.69724 3.64628 8.48424ZM10.7433 0.213239L10.8773 0.254239L11.0083 0.297906C11.1695 0.354442 11.3158 0.446943 11.436 0.568399C11.5562 0.689854 11.6471 0.837077 11.7019 0.998906C12.2243 2.52491 12.0583 4.07091 11.2163 5.60357C10.8693 6.23491 10.4253 6.83257 9.88495 7.39624L9.73528 7.54924L9.59362 7.68791L9.58962 7.73091C9.49128 8.64891 8.79495 9.86291 7.51195 11.4326L7.40062 11.5682L7.19562 11.8132C6.96362 12.0886 6.53162 12.0119 6.39628 11.6866L6.38028 11.6429L5.66295 9.35357L5.59795 9.30857C5.19488 9.02143 4.81096 8.70832 4.44862 8.37124L4.27028 8.20124L4.09562 8.02791C3.5797 7.50291 3.11535 6.92961 2.70895 6.31591L2.66928 6.25424L0.333283 5.49891C0.00461593 5.39224 -0.101384 4.98591 0.107283 4.73057L0.134949 4.69924L0.164949 4.67124C2.08628 2.99257 3.50395 2.16024 4.51928 2.22957L4.58462 2.23524L4.62262 2.23991L4.70828 2.15324C5.16895 1.69524 5.65128 1.30557 6.15562 0.985239L6.32428 0.880906L6.47928 0.790239C7.88662 -0.00776076 9.31528 -0.204094 10.7433 0.213573V0.213239ZM6.43695 3.43691C5.85262 4.02157 5.85462 4.97124 6.44162 5.55824C7.02862 6.14524 7.97828 6.14724 8.56295 5.56291C9.14728 4.97824 9.14528 4.02857 8.55828 3.44157C7.97128 2.85457 7.02162 2.85257 6.43695 3.43691Z" fill="url(#paint0_linear_1194_1463)" />
                                    <defs>
                                        <linearGradient id="paint0_linear_1194_1463" x1="5.99989" y1="0" x2="5.99989" y2="11.9999" gradientUnits="userSpaceOnUse">
                                            <stop stopColor="#b3c3ff" />
                                            <stop offset="1" stopColor="var(--color-primary)" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </span>
                            <Text as="h2" variant="headingMd">{t("Upgrade to unlock this feature")}</Text>
                        </div>
                        <BlockStack gap={200}>
                            <Text as="h2" variant="headingLg">
                                {
                                    planType === 'pro' ? (
                                        planInfoData.pro?.trial_days > 0 ? t("Try SEOWILL Pro For Free") : t("Get SEOWILL Pro Now")
                                    ) :
                                        planType === 'pre' ? (
                                            planInfoData.pre?.trial_days > 0 ? t("Try SEOWILL Premium For Free") : t("Get SEOWILL Premium Now")
                                        ) : ""
                                }
                            </Text>
                            <Text variant="bodyMd" as="p" tone="subdued">
                                {
                                    planType === 'pro' ? (
                                        planInfoData.pro?.trial_days > 0 ? t("{{v1}}-day free trial · Cancel anytime", planInfoData.pro?.trial_days) : t("Boost your website traffic 4.2x with SEOWILL Pro")
                                    ) :
                                        planType === 'pre' ? (
                                            planInfoData.pre?.trial_days > 0 ? t("{{v1}}-day free trial · Cancel anytime", planInfoData.pre?.trial_days) : t("Boost your website traffic by 4.2x with SEOWILL Premium")
                                        ) : ""
                                }
                            </Text>
                        </BlockStack>

                        {/* Subtitle */}
                        {/* Features list */}
                        <div className="features-section">
                            <Text variant="bodySm" as="p" tone="subdued">{planType === 'pro' ? t("Here's what you'll get") : t("Get everything in Pro, plus")}:</Text>
                            <ul className="features-list">
                                {
                                    planType === 'pro' ? (
                                        proList.map((item, index) => {
                                            return <li className="feature-item" key={index}>
                                                <span className="check-icon">{checkIcon}</span>
                                                <span>{item}</span>
                                            </li>
                                        })
                                    ) : (
                                        preList.map((item, index) => {
                                            return <li className="feature-item" key={index}>
                                                <span className="check-icon">{checkIcon}</span>
                                                <span>{item}</span>
                                            </li>
                                        })
                                    )
                                }
                            </ul>
                        </div>

                        {/* Action buttons */}
                        <div className="action-buttons">
                            <Button variant="primary" size="large" loading={planLoading || paidLoading} onClick={handleUpgradePlan}>
                                {
                                    planType === 'pro' ? (
                                        planInfoData.pro?.trial_days > 0 ? t("Try Free For {{v1}} Days", planInfoData.pro?.trial_days) : t("GET PRO NOW")
                                    ) :
                                        planType === 'pre' ? (
                                            planInfoData.pre?.trial_days > 0 ? t("Try Free For {{v1}} Days", planInfoData.pre?.trial_days) : t("GET PREMIUM NOW")
                                        ) : ""
                                }
                            </Button>
                            <Button size="large" onClick={() => jumpPricing()}>{t("View All Plans")}</Button>
                        </div>
                    </div>

                    {/* Right Section */}
                    <div className="right-section">
                        <img className="right-section-img" src="/imgs/Image/load_img.png" alt="" />
                        <img src={imgUrl} alt="" />
                    </div>
                </div>
            </div>
        </Modal>
    );

    return modalContent;
}

export default withRouter(NewDiscountUpgradeModal);